"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Box = _interopRequireDefault(require("@commerce-ui/core2/Box"));
var _MenuItemButton = _interopRequireDefault(require("@deosite/components-new/MenuItemButton"));
var _LabelWithImage = require("@deosite/components-new/LabelWithImage");
var __jsx = _react["default"].createElement;
var MenuItemsList = function MenuItemsList(props) {
  var title = props.title,
    menuItems = props.menuItems;
  return __jsx(_Box["default"], null, title && __jsx(_Box["default"], {
    as: "h1",
    sx: {
      color: "main",
      textAlign: "center",
      my: "s9",
      pb: "s8",
      font: "heading2"
    }
  }, title), __jsx(_Box["default"], {
    sx: {
      display: "flex",
      flexDirection: "column"
    }
  }, menuItems.map(function (menuItem, index) {
    return __jsx(_Box["default"], {
      sx: {
        height: "52px"
      },
      key: index
    }, __jsx(_MenuItemButton["default"], {
      sx: {
        border: "0px",
        borderBottomWidth: "1px",
        cursor: "pointer",
        background: "transparent",
        borderStyle: "solid",
        borderColor: "neutral",
        minWidth: "100%",
        maxWidth: "100%",
        minHeight: "100%",
        maxHeight: "100%"
      },
      label: menuItem.label,
      url: menuItem.url,
      onClick: menuItem.onCategoryClick,
      additionalLabel: menuItem.additionalLabel,
      image: null,
      button: "true",
      labelMode: _LabelWithImage.LABEL_MODE.labelRight
    }));
  })));
};
var _default = MenuItemsList;
exports["default"] = _default;